module.exports = __webpack_public_path__ + "img/zhiyuan-pro.ef5d3e96.jpg";